const formatTime = (startTime: any, endTime: any) => {
  const start = new Date();
  const end = new Date();
  // Format start date
  if (startTime && endTime) {
    const timeStart = startTime.split(":");
    start.setHours(timeStart[0]);
    start.setMinutes(timeStart[1]);
    // Format end date
    const timeEnd = endTime.split(":");
    end.setHours(timeEnd[0]);
    end.setMinutes(timeEnd[1]);
  }

  return { start, end };
};

const getTwoDigitsTime = (time: string) => {
  const [hour = "00", minute = "00", second = "00"] = time.split(":");
  return [hour.padStart(2, "0"), minute.padStart(2, "0"), second.padStart(2, "0")];
};

const getDateKey = (date: string, start: string, end: string) => {
  const [startHour, startMinute, startSecond] = getTwoDigitsTime(start);
  const [endHour, endMinute, endSecond] = getTwoDigitsTime(end);

  const startTime = `${startHour}:${startMinute}:${startSecond}`;
  const endTime = `${endHour}:${endMinute}:${endSecond}`;

  return `${date} ${startTime} - ${endTime}`;
};

export { formatTime, getTwoDigitsTime, getDateKey };
